import React from 'react'
import Hadear from './layout/Hadear'
import Footer from './layout/Footer'
import { Outlet } from 'react-router-dom';

const MainLayOut = () => {
  return (
    <div className="font-karla text-body text-tiny offcanvas-open">
      <Hadear />
      <Outlet />
      <Footer />
    </div>
  );
}

export default MainLayOut